<template>
  <CustomModal @close="$emit('close')">
    <template v-slot:body>
      <div v-if="completed" class="py-10 flex flex-col import-space-modal">
        <div class="bg-green p-6 rounded-full text-white mx-auto mb-4">
          <font-awesome-icon icon="check" class="text-xl"/>
        </div>
        <div class="text-xl font-bold text-text leading-tight mb-4 text-center">{{ $t('importCompleted') }}</div>
        <div class="text-text" v-if="!!importResultsCount">
          <div class="text-md">{{ $t('added') }}:</div>
          <div class="text-sm mb-4">
            <div v-for="(result,i) in importResultsCount">
              - <b>{{ result }}</b> {{ $tc(`${i}Result`, result) }}
            </div>
          </div>
          <div class="text-sm text-text-ternary text-center">{{ $t('notice') }}</div>
        </div>
        <div class="text-text text-lg text-center" v-else>
          {{ $t('nothingToAdd') }}
        </div>
      </div>
      <div class="import-space-modal space-y-12" v-else>
        <div class="text-xl font-bold text-text leading-tight mb-4">{{ $t('importSpaceTitle') }}</div>
        <BaseSelect
            v-model="service"
            :options="servicesList"
            track-by="id"
            label="name"
            :class="{'--error':$v.service.$error}"
            :disabled="submitted"
            :select-label="$t('serviceLabel')"
            :allow-empty="false"
            :searchable="false"
            :show-labels="false">
          <template v-slot:errors>
            <div class="error" v-if="$v.service.$invalid">{{ $t('fieldRequired') }}</div>
          </template>
        </BaseSelect>
        <FileUpload v-model="report"
                    :accept="['csv', 'xls', 'xlsx', 'db']"
                    :multiple="false"
                    class="max-w-full"/>
        <BaseButton @click="submit"
                    :loading="submitted"
                    theme="gray"
                    class="w-full">
          {{ $t('importBtn') }}
        </BaseButton>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseButton from "@/components/UI/BaseButton";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import FileUpload from "@/components/common/FileUpload";

export default {
  name: "SpaceImportModal",
  components: {FileUpload, BaseSelect, BaseButton, CustomModal},
  data() {
    return {
      service: null,
      report: [],
      submitted: false,
      importResults: null,
      completed: false
    }
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    servicesList() {
      return this.getConstantList('space_import')
    },
    importResultsCount() {
      if (!this.importResults) return null;
      const count = {}
      Object.keys(this.importResults).forEach(item => {
        if (this.importResults[item].length) {
        }
        count[item] = this.importResults[item].length
      })
      return count;
    }
  },
  validations: {
    service: {
      required,
    },
  },
  methods: {
    ...mapActions('space', ['importSpace']),
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.report.length) {
        if (!this.report.length) this.$toasted.error('Добавьте файл!')
      } else {
        this.submitted = true;
        try {
          const res = await this.importSpace({service: this.service.id, report: this.report});
          if (res.body.success) {
            this.service = '';
            this.report = [];
            this.importResults = this.filterResultObject(res.body.data);
            this.completed = true;
            this.$v.$reset();
          } else {
            this.$toasted.error(res.body.message)
            console.log(res)
          }
        } catch (err) {
          this.$toasted.error('Что-то пошло не так...')
          console.log(err)
        } finally {
          this.submitted = false;
        }
      }
    },
    filterResultObject(results) {
      let anyResults = {}
      Object.keys(results).forEach(key => {
        if (results[key].length) {
          anyResults[key] = results[key]
        }
      })
      return Object.keys(anyResults).length ? anyResults : null;
    }
  },
  i18n: {
    messages: {
      en: {
        importSpaceTitle: 'Import file',
        serviceLabel: 'Service',
        importBtn: 'Import',
        fieldRequired: 'Field is required',
        importCompleted: 'File successfully uploaded',
        added: 'Read',
        transactionsResult: '| transaction | transactions',
        newIncomeSourcesResult: '| income source | income sources',
        newExpenseCategoriesResult: '| expense category | expense categories',
        newAccountsResult: '| account | accounts',
        newContractorsResult: '| contractor | contractors',
        newTagsResult: '| tag | tags',
        notice: 'This window can be closed, data will be loaded in background.',
      },
      ru: {
        importSpaceTitle: 'Загрузка файла',
        serviceLabel: 'Сервис',
        importBtn: 'Импортировать',
        fieldRequired: 'Поле обязательно',
        importCompleted: 'Файл успешно загружен',
        added: 'Прочитано',
        transactionsResult: '| транзакция | транзакции | транзакций',
        newIncomeSourcesResult: '| источник дохода | источника дохода | источников дохода',
        newExpenseCategoriesResult: '| категория расхода | категории расхода | категорий расхода',
        newAccountsResult: '| счёт | счёта | счётов',
        newContractorsResult: '| контрагент | контрагента | контрагентов',
        newTagsResult: '| тэг | тэга | тэгов',
        nothingToAdd: 'Ничего не добавлено',
        notice: 'Это окно можно закрыть, данные будут загружены в фоновом режиме.',
      }
    }
  }
}
</script>

<style scoped>
.import-space-modal {
  width: 250px;
  max-width: 250px;
}
</style>